// Central configuration file to avoid circular dependencies
// Determine API URL based on environment

export const getApiUrl = () => {
  // In production (when served from same domain), use /api
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // In development, use env var or localhost fallback
  let url = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001/api';
  
  // Normalize URL to ensure it ends with /api
  // Remove trailing slash if present
  if (url.endsWith('/')) {
    url = url.slice(0, -1);
  }
  
  // Append /api if missing
  if (!url.endsWith('/api')) {
    url += '/api';
  }
  
  return url;
};

export const API = getApiUrl();

console.log('[Config] API URL configured as:', API);
